/**
 * Lock Body Scroll
 * @param  {String}  focusContainer    Element to trap the focus into while page in locked
 * @param  {Boolean} disableEffectHook Define if the function is used into a useEffect or not
 * @return {}                          Lock the scroll on <body> when hook is in effect
 */

import { useEffect } from 'react'

const useLockBodyScroll = (focusContainer, disableEffectHook) => {
  if (disableEffectHook) {
    // Plain function - Lock/unlock the <body> when invoking the function 
    if (focusContainer && focusContainer !== null) {
      document.body.style.overflow = 'hidden'
      document.body.classList.add('body-locked')
    } else {
      document.body.style.overflow = 'visible'
      document.body.classList.remove('body-locked')
    }
  } else {
    // Effect Hook - Lock the <body> when the component mount
    useEffect(() => {
      document.body.style.overflow = 'hidden'
      document.body.classList.add('body-locked')

      // Trap the focus into the form
      if (focusContainer) {
        focusContainer.setAttribute('tabindex', '0')
        focusContainer.classList.add('focus-container')
        focusContainer.addEventListener('focusout', (ev) => {
          if (!focusContainer.contains(ev.relatedTarget)) {
            focusContainer.focus()
          }
        })
      }

      // Restore the <body> scroll when component unmount
      return () => (
        document.body.style.overflow = 'visible',
        document.body.classList.remove('body-locked')
      )
    })
  }
}
export default useLockBodyScroll